import React from "react";
import {
    Popover,
    PopoverProps,
    Button
  } from '@amzn/awsui-components-console';
  import 'src/components/commonComponents/common.css'

  export const ButtonPopover = (props: PopoverProps) => {
  
    return (
      <Popover content={props.content} position={props.position ?? "right"} size={props.size} triggerType="custom">
        <Button className="navbar-brand" iconName="status-info" variant="icon" />
      </Popover>
    )
  }